"use strict";
var pageLogo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve, reject) {
    pageLogo.addEventListener("click", function(e) {
        resolve(e.target);
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected!"));
    }, 3000);
});
promise1.then(function() {
    var message = document.createElement("div");
    message.classList.add("message");
    message.textContent = "Promise was resolved!";
    document.body.append(message);
}).catch(function() {
    var message = document.createElement("div");
    message.classList.add("message", "error-message");
    message.textContent = "Promise was rejected!";
    document.body.append(message);
});
promise2.then(function() {
    var message = document.createElement("div");
    message.classList.add("message");
    message.textContent = "Promise was resolved!";
    document.body.append(message);
}).catch(function() {
    var message = document.createElement("div");
    message.classList.add("message", "error-message");
    message.textContent = "Promise was rejected!";
    document.body.append(message);
});

//# sourceMappingURL=index.ca095efd.js.map
